import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Splash() {
  const navigate = useNavigate();
  useEffect(()=>{
    const t = setTimeout(()=> navigate('/access'), 5000);
    return ()=> clearTimeout(t);
  },[navigate]);
  return (
    <div className="min-h-screen relative overflow-hidden" style={{animation:'ani_gradient 21s ease infinite', background:'linear-gradient(-60deg, #F505D5 15%, #F507F5 19%, #2525FA 54%, #42F2FF 85%)', backgroundSize:'200% 200%'}}>
      <style>{`@keyframes ani_gradient{0%{background-position:0% 0%}50%{background-position:100% 100%}100%{background-position:0% 0%}}`}</style>
      <div className="h-screen grid place-items-center px-6">
        <img src="/assets/digifit_splash.png" alt="DigiFit splash" className="mx-auto w-[364px] sm:w-[468px]"/>
      </div>
    </div>
  );
}
